<template>
<div class="delivery-calc-item" :class="{'delivery-calc-compound': modelValue.compound}">
  <FormSelect :options="types" v-model="modelValue.compound" />
  <div class="delivery-calc-single" v-if="!modelValue.compound">
    <ul class="delivery-calc-conditions">
    <li v-for="(item, ii) in modelValue.conditions || []">
      <FormSelect v-model="item.type" :options="conditionTypes" />
      <FormInput v-model="item.value" />
      <button v-on:click.prevent="removeCondition(ii)" class="btn btn-danger"><i class="fas fa-xmark"></i></button>
    </li>
      <li class="new">
        <button v-on:click.prevent="addCondition" class="btn btn-primary"><i class="fas fa-plus"></i></button>
      </li>
    </ul>
    <div class="delivery-calc-target">
      <FormSelect v-model="modelValue.targetType" :options="targetTypes" />
      <FormInput v-if="modelValue.targetType=='flat'" v-model="modelValue.value" />
      <FormInput v-if="modelValue.targetType=='percentOfValue'" v-model="modelValue.value" />
      <FormInput v-if="modelValue.targetType=='pricePerKg'" v-model="modelValue.value" />
      <FormTextAuto v-if="modelValue.targetType=='valueRanges'" v-model="modelValue.value" :placeholder="valueRangesPlaceholder" />
      <FormTextAuto v-if="modelValue.targetType=='weightRanges'" v-model="modelValue.value" :placeholder="weightRangesPlaceholder" />
    </div>
  </div>
  <ul class="delivery-calc-list" v-else>
    <li v-for="(item, ii) in modelValue.items || []">
      <FormDeliveryPriceCalcItem v-model="modelValue.items[ii]" />
      <button v-on:click.prevent="removeRule(ii)" class="btn btn-danger"><i class="fas fa-xmark"></i></button>
    </li>
    <li class="new">
      <button v-on:click.prevent="addRule" class="btn btn-primary"><i class="fas fa-plus"></i></button>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  props: ["modelValue"],
  data: ()=>({
    types: [
      {value: null, text: "-"},
      {value: 'min', text: "Min"},
      {value: 'max', text: "Max"},
      {value: 'sum', text: "Sum"},
    ],
    conditionTypes: [
      {value: 'cartTotalMin', text: 'Minimum cart value'},
      {value: 'cartTotalMax', text: 'Maximum cart value'},
      {value: 'weightMin', text: 'Minimum cart weight'},
      {value: 'weightMax', text: 'Maximum cart weight'},
    ],
    targetTypes: [
      {value: 'flat', text: 'Flat price'},
      {value: 'percentOfValue', text: 'Percent of cart value'},
      {value: 'pricePerKg', text: 'Price per kg'},
      {value: 'valueRanges', text: 'Value ranges'},
      {value: 'weightRanges', text: 'Weight (kg) ranges'},
    ],
    valueRangesPlaceholder: "900 = 100 (upper limit = delivery price)",
    weightRangesPlaceholder: "2 = 200 (upper limit (kg) = delivery price)",
  }),
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    addRule() {
      this.modelValue.items=this.modelValue.items || [];
      this.modelValue.items.push({compound: null});
    },
    removeRule(index) {
      this.modelValue.items.splice(index, 1);
    },
    addCondition() {
      this.modelValue.conditions=this.modelValue.conditions || [];
      this.modelValue.conditions.push({type: 'cartTotalMin', value: null, targetType: null});
    },
    removeCondition(index) {
      this.modelValue.conditions.splice(index, 1);
    },
  },
}
</script>
